const biliaRanges = ref([
  //Bilia external IP
  '62.20.106.218/32',
  '95.193.101.118/32',
  '194.236.230.10/32',
  '194.236.14.254/32',
  '195.67.128.14/32',
  '82.134.52.78/32 ',
  '62.60.13.22/32',
  '194.1.212.225/32',
  '212.88.238.34/32',
  '84.199.124.22/32',
  '213.211.184.228/32 ',
  '153.92.50.106/32',
  '77.109.84.198/32 ',
  '153.92.50.107/32',
  '213.211.184.227/32',
  '77.109.121.127/32',
  '31.172.147.6/32',
  '153.92.49.109/32',
  '153.92.49.110/32',
  '212.247.163.242/32',
  '194.218.207.250/32',
  '62.20.13.30/32',
  '212.181.32.182/32',
  '195.198.29.206/32',
  '62.20.102.90/32',
  '213.236.232.110/32',
  '146.247.179.190/32',
  '37.202.57.202/32',
  '195.198.39.190/32',
  '194.237.238.66/32',
  '62.20.86.146/32',
  '62.20.106.222/32',
  '212.181.53.230/32',
  '212.181.53.30/32',
  '213.236.232.126/32',
  '213.236.232.114/32',
  '213.236.233.38/32',
  '195.196.138.156/32',
  '195.67.139.50/32',
  '213.236.233.2/32',
  '212.181.116.202/32',
  '212.181.121.62/32',
  '213.236.233.34/32',
  '62.20.110.102/32',
  '194.218.243.110/32',
  '213.236.232.118/32',
  '213.236.232.106/32',
  '213.236.232.122/32',
  '194.218.46.38/32',
  '213.236.232.98/32',
  '194.18.226.50/32',
  '213.236.233.10/32',
  '62.20.98.174/32',
  '213.236.233.6/32',
  '194.237.244.106/32',
  '194.218.219.162/32',
  '62.20.82.86/32',
  '62.20.109.198/32',
  '194.218.243.114/32',
  '213.236.233.26/32',
  '212.181.53.26/32',
  '195.67.152.186/32',
  '212.181.112.10/32',
  '195.67.84.54/32',
  '62.20.93.6/32',
  '85.19.192.110/32',
  '194.22.56.62/32',
  '213.188.29.250/32',
  '212.181.23.170/32',
  '62.20.80.14/32',
  '213.236.233.70/32',
  '213.236.233.30/32',
  '194.22.22.26/32',
  '194.237.252.22/32',
  '194.237.95.86/32',
  '62.20.84.234/32',
  '153.92.49.110/32',
  '194.236.216.30/32',
  '194.22.20.66/32',
  '195.198.11.194/32',
  '153.92.49.109/32',
  '213.236.233.22/32',
  '62.20.84.230/32',
  '195.198.29.202/32',
  '195.67.89.182/32',
  '212.181.59.134/32',
  '62.20.86.22/32',
  '62.20.81.250/32',
  '89.151.248.114/32',
  '194.218.220.158/32',
  '62.20.82.74/32',
  '62.20.66.6/32',
  '83.241.210.90/32',
  '146.247.185.116/32',
  '146.247.185.117/32',
  '213.236.233.74/32',
  '146.247.187.69/32',
  '146.247.187.70/32',
  '83.241.210.86/32',
  '83.241.210.82/32',
  '194.236.14.74/32',
  '213.236.233.18/32',
  '195.67.10.42/32',
  '194.18.255.58/32',
  '85.19.202.106/32',
  '81.237.197.9/32',
  '194.218.217.134/32',
  '213.236.233.114/32',
  '213.236.232.102/32',
  '213.52.34.201/32',
  '213.236.233.62/32',
  '194.22.22.34/32',
  '212.181.4.102/32',
  '194.22.22.2/32',
  '62.20.82.202/32',
  '213.236.233.58/32',
  '95.155.217.88/32',
  '88.129.68.154/32',
  '194.22.62.106/32',
  '195.198.76.38/32',
  '194.218.220.166/32',
  '194.16.194.238/32',
  '194.22.57.218/32',
  '213.236.233.14/32',
  '212.181.11.54/32',
  '213.236.233.50/32',
  '213.145.173.214/32',
  '213.145.173.106/32',
  '194.22.18.26/32',
  '62.20.13.22/32',
  '212.181.98.230/32',
  '194.22.22.18/32',
  '212.181.39.118/32',
  '194.22.22.14/32',
  '62.20.81.254/32',
  '194.22.19.46/32',
  '62.20.66.2/32',
  '213.236.233.78/32',
  '213.236.233.54/32',
  '213.236.233.42/32',
  '62.20.103.58/32',
  '194.237.250.250/32',
  '212.181.116.186/32',
  '212.181.121.82/32',
  '62.20.85.6/32',
  '195.67.63.78/32',
  '195.198.56.10/32',
  '212.181.72.170/32',
  '194.237.36.82/32',
  '212.181.63.178/32',
  '194.237.250.254/32',
  '31.208.70.246/32',
  '195.198.70.42/32',
  '213.236.233.250/32',
  '62.20.84.238/32',
  '194.218.220.170/32',
  '62.20.67.106/32',
  //Staff
  '151.252.172.196/24', //Jimmie
  '193.234.109.147', //Kim
]);

const ipToInt = (ip: string) => ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);

const isIPInRange = (ipInt: number, range: string) => {
  const [rangeStart, subnetMask] = range.split('/');

  if (subnetMask) {
    const rangeStartInt = ipToInt(rangeStart);
    const rangeEndInt = rangeStartInt + (1 << (32 - parseInt(subnetMask, 10)));
    return ipInt >= rangeStartInt && ipInt <= rangeEndInt;
  } else {
    return ipInt == ipToInt(rangeStart);
  }
};

export const inBiliaNetwork = (ip: string) => {
  const ipInt = ipToInt(ip);
  return biliaRanges.value.some((range) => isIPInRange(ipInt, range));
};
